import { useTabsPanelContext } from '@/components/ui/custom/dataDisplay/Tabs/Tabs';
import useConfigContext from '@/data/hook/config';
import { AstroWorkspace, Workspace } from '@cna-br/astro-code';
import { twMerge } from 'tailwind-merge';
import { blockCodeToolbox } from './blockCodeToolbox';

type WorkspaceProps = {
  workspace: Workspace | undefined;
  onWorkspaceChange?: (workspace: Workspace) => void;
  maxBlocks?: number;
  className?: string;
  readOnly?: boolean;
};

const BlockCode = (props: WorkspaceProps) => {
  const { triggerListSize } = useTabsPanelContext();
  const { userSettings } = useConfigContext();

  const theme = userSettings?.theme || 'light';

  return (
    <AstroWorkspace
      data-trigger={triggerListSize}
      className={twMerge('h-[18.75rem]', props.className)}
      theme={theme}
      toolboxMenu={blockCodeToolbox}
      readOnly={props.readOnly}
      {...props}
    />
  );
};

export default BlockCode;
